import { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import SectionHeading from '@/components/base/SectionHeading';
import { topics } from '@/mocks/topics';

type TabKey = 'day' | 'week';

export default function RankingBoard() {
  const [tab, setTab] = useState<TabKey>('day');

  const dayList = [...topics].sort((a, b) => b.heat - a.heat);
  const weekList = [...topics].sort(
    (a, b) => b.updates.length - a.updates.length || b.heat - a.heat,
  );
  const list = (tab === 'day' ? dayList : weekList).slice(0, 6);
  const maxHeat = Math.max(...list.map((item) => item.heat));

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <Container>
        <SectionHeading
          eyebrow="Trending Board"
          title="追踪榜"
          desc="按关注热度与更新频率综合排序，帮你快速定位当前最值得跟进的线索。"
        />

        <div className="mt-8">
          <div className="inline-flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
            <button
              type="button"
              onClick={() => setTab('day')}
              className={`cursor-pointer whitespace-nowrap rounded-full px-5 py-1.5 text-sm font-medium transition-colors ${
                tab === 'day' ? 'bg-primary-600 text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              日榜
            </button>
            <button
              type="button"
              onClick={() => setTab('week')}
              className={`cursor-pointer whitespace-nowrap rounded-full px-5 py-1.5 text-sm font-medium transition-colors ${
                tab === 'week' ? 'bg-primary-600 text-background-50' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              周榜
            </button>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-x-12 gap-y-1 lg:grid-cols-2">
          {list.map((topic, index) => (
            <Link
              key={topic.slug}
              to={`/topic/${topic.slug}`}
              className="group flex cursor-pointer items-center gap-4 border-b border-background-200 py-4"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  index < 3 ? 'bg-primary-600 text-background-50' : 'bg-background-200 text-foreground-700'
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                    {topic.title}
                  </span>
                </div>
                <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <span
                    className="block h-full rounded-full bg-accent-500"
                    style={{ width: `${Math.round((topic.heat / maxHeat) * 100)}%` }}
                  ></span>
                </div>
              </div>
              <div className="shrink-0 text-right">
                <p className="font-heading text-sm font-bold text-foreground-950">{topic.heat}</p>
                <p className="text-[11px] text-foreground-500">{topic.categoryName}</p>
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}